import { useMutation } from "@tanstack/react-query";
import { CheckCircle2 } from "lucide-react";
import { Link, useSearchParams } from "react-router";

import { useSession } from "@/auth/session";
import { AuthLayout } from "@/components/layout";
import { Alert, buttonClass, ErrorAlert, FullPageSpinner } from "@/components/ui";
import { auth, session } from "@/lib/api";
import { useOnce } from "@/pages/auth/helpers";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const s = useSession();
  const verify = useMutation({
    mutationFn: () => auth.verifyEmail(token),
    onSuccess: (user) => session.updateUser(user),
  });
  useOnce(() => {
    if (token) verify.mutate();
  });
  return (
    <AuthLayout title="Verify your e-mail">
      {!token && <Alert tone="danger">This link is incomplete.</Alert>}
      {verify.isPending && <FullPageSpinner />}
      {verify.error && <ErrorAlert error={verify.error} />}
      {verify.isSuccess && (
        <div className="space-y-4 text-center">
          <CheckCircle2 className="mx-auto size-10 text-brand-600" />
          <p className="text-sm text-fg-muted">{verify.data.email} is verified.</p>
          <Link
            to={s.status === "signed_in" ? "/" : "/login"}
            className={buttonClass("primary", "md", "w-full")}
          >
            Continue
          </Link>
        </div>
      )}
    </AuthLayout>
  );
}
